module.exports = __webpack_public_path__ + "static/media/julia-win.7d6f4368.jpg";